import { useUser } from 'reactfire'
import useDoc from './use-doc'
import { Customer } from '../../models/customer'

const useCustomer = () => {
  const { data: authUser } = useUser()
  return useDoc<Customer>(authUser ? `customers/${authUser?.uid}` : '')
}

export default useCustomer